const createElement:()=> Window|HTMLDivElement = (function () {
  const targetElement = window ?? document?.createElement('div');
  return function () {
    return targetElement;
  };
}());

let instance;

export type GlobalListenerObject = {
  callee: any;
  id: number;
  eventName: string;
  eventHandler: EventListenerOrEventListenerObject,
  config,
  unsubscribe: () => void;
};

export type GlobalEventListenerProps = {};

class GlobalEventListenerClass {

  listenerCount:number = 0;

  listeners: Map<string, GlobalListenerObject[]> = new Map();

  element: Window|HTMLDivElement;

  constructor() {

    if(instance){
      return instance;
    }

    this.listenerCount = 0;
    this.listeners = new Map();
    this.element = createElement();
    instance = this;
  }

  static getInstance() {
    return new GlobalEventListenerClass();
  }

  getElement() {
    return this.element;
  }

  emit(eventName, detail) {
    // @ts-ignore
    if(eventName === 'IS_PAUSE_ENABLED') console.log('emitEvent', eventName, detail);
    const event = new CustomEvent(eventName, { detail });
    const el = this.getElement();
    el.dispatchEvent(event);
  }

  listen(eventName, eventHandler, options = {}) {
    // @ts-ignore
    if(eventName === 'IS_PAUSE_ENABLED') console.log('listen', eventName, '[func]', options);
    const config = { ...{ once: false }, ...options };

    if(!this.listeners.has(eventName)) {
      this.listeners.set(eventName, []);
    }

    this.listenerCount+=1;
    const id = this.listenerCount;
    const el = this.getElement();
    el.addEventListener(eventName, eventHandler, config);

    const listener = {
      callee: this,
      id,
      eventName,
      eventHandler,
      config,
      unsubscribe: () => {
        el.removeEventListener(eventName, eventHandler, false);
        const existingListeners = this.listeners.get(eventName);
        this.listeners.set(eventName, existingListeners.filter(l => l.id === id));
      }
    };

    const existingListeners = this.listeners.get(eventName);
    this.listeners.set(eventName, [...existingListeners, listener]);

    return () => {
      // const index = this.listeners.get(eventName).findIndex(l => l.id === id);
      // const listener = this.listeners.get(eventName)[index];
      // @ts-ignore
      if(eventName === 'IS_PAUSE_ENABLED') console.log('!!!!!! unsubscribe', {eventName, id, listener});
      return listener.unsubscribe();
    };
  }
}

export {
  GlobalEventListenerClass
}